import { useEffect, useState } from "react";

// Tiny hook around window.matchMedia. Returns the live boolean for whether
// the supplied CSS media query currently matches.
//
// Usage:
//   const isDesktop = useMediaQuery("(min-width: 1024px)");
//   const prefersDark = useMediaQuery("(prefers-color-scheme: dark)");
export default function useMediaQuery(query) {
  const get = () => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  };
  const [matches, setMatches] = useState(get);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    // addEventListener is the modern API; fallback to addListener for old Safari.
    if (mql.addEventListener) {
      mql.addEventListener("change", handler);
      return () => mql.removeEventListener("change", handler);
    } else {
      mql.addListener(handler);
      return () => mql.removeListener(handler);
    }
  }, [query]);

  return matches;
}
